<script setup lang="ts">
import { Prop } from 'vue'
// components
import BasketGiftsItem from '~/components/Basket/basket-gifts/BasketGiftsItem.vue'
// types
import { SelectedGift } from '~/types/store/basket'
import { GiftProduct } from '~/types/api/api-v3/basket'

const emit = defineEmits(['selectGift'])
const props = defineProps({
  products: {
    type: Array,
    required: true,
  } as Prop<GiftProduct[]>,
  ruleId: {
    type: Number,
    required: true,
  },
  isGiftNeed: {
    type: Boolean,
    required: true,
  },
  selectedGift: {
    type: Object,
    required: true,
  } as Prop<SelectedGift>,
})

const selectGift = (productId: number) =>
  emit('selectGift', {
    rule_id: props?.ruleId,
    product_id: productId,
  })
</script>

<template>
  <div class="gifts-list">
    <basket-gifts-item
      v-for="gift in products"
      :key="gift.title"
      :gift="gift"
      :is-gift-selected="selectedGift?.product_id === gift.product_id"
      :is-gift-need="isGiftNeed"
      @select-gift="selectGift(gift.product_id)"
    />
  </div>
</template>

<style lang="scss" scoped>
.gifts-list {
  display: flex;
  gap: 0 16px;
  justify-content: flex-start;
  scroll-snap-type: x mandatory;
  scroll-padding-inline: 20px;
  padding: 0 20px;
  margin: 0 -20px 16px;

  @include media('<tablet') {
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
